<template>
  <div>

    <div class="container-fluid">
      <div class="row ">
        <div class="col-12 p-0">
          <div class="login-card">
            <div>
              <div>
                <a class="logo">
                  <img class="img-fluid for-light" src="../assets/images/logo/login/login_vue.png" height="160" width="250" alt="looginpage" />
                  <img class="img-fluid for-dark" src="../assets/images/logo/login/login_vue2.png" height="160" width="250" alt="looginpage" />
                </a>
              </div>
              <div class="login-main">
                <form class="theme-form">
                  <h4>Sign in to account</h4>
                  <p>Enter your username & password to login</p>
                  <div class="form-group">
                    <label class="col-form-label">Username</label>
                    <input class="form-control" type="text" required="" placeholder=""
                      v-model="username">
                    <span class="validate-error">{{
                        username.errormsg }}</span>

                  </div>
                  <div class="form-group">
                    <label class="col-form-label">Password</label>
                    <div class="form-input position-relative">
                      <input class="form-control" :type="isPasswordVisible ? 'text' : 'password'" name="login[password]" required=""
                        placeholder="*********" v-model="password">
                      <span class="validate-error" v-if="password.length < 7">{{ password.errormsg}}</span>
                      <div class="show-hide position-absolute top-50 end-0 translate-middle-y pe-3" style="cursor: pointer;" @click="showPassword()">
                        <i :class="isPasswordVisible ? 'fa fa-eye' : 'fa fa-eye-slash'" aria-hidden="true"></i>
                      </div>
                    </div>
                  </div>
                  <div class="form-group mb-0">
                    <div class="text-end mt-3">
                      <button class="btn btn-primary btn-block w-100" type="submit" @click.prevent="onSubmit">Sign
                        in</button>

                    </div>
                  </div>
                </form>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>


export default {
  name: 'login',
  data() {
    return {

      result: { username: '', password: '' },
      username: "",
      password: "",  
      isPasswordVisible: false,
    };
  },

  created() {

  },
  methods: {
    showPassword() {
      this.isPasswordVisible = !this.isPasswordVisible;
      return this.isPasswordVisible;
    },
    onSubmit() {
        
        var data = JSON.stringify({
            "username": this.username,
            "password": this.password
        });

        const config = {
           headers: {
             "Content-Type": "application/json",
             "Accept": "application/json",
           },
        };

        this.errors = {};
        this.$axios
        .post("trazio/login", data, config)
        .then((response) => {
          console.log(response);
          if(response.status == 200) {
              
            var responseData = response.data.data.details;
            console.log(responseData);

            if (responseData.token) 
            {
              localStorage.setItem('trazio', JSON.stringify(responseData));   
              this.token = responseData.token;
             
              this.$router.push({ name: "dashboard" });
                
                this.$swal("", response.data.message, "success");        
              
            } else {
                this.$swal("", "Failed to fetch token, please try again", "error");
            }
            
          }
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response);
          if (error.response) {
            if (error.response.status == 422) {
              if (error.response.data) {
                if (error.response.data.message.username) 
                {
                  this.errors = error.response.data.message.username[0];
                  this.$swal("", error.response.data.message.username[0], "error");
                }
                else if(error.response.data.message.password)
                {
                  this.errors = error.response.data.message.password[0];
                  this.$swal("", error.response.data.message.password[0], "error");
                }
                else {
                  this.errors = error.response.data.message;
                  this.$swal("", error.response.data.message, "error");
                }
                
              }
            } else if (error.response.status == 500) {
              this.$swal("", error.response.statusText, "error");
            } else if (error.response.status == 401) {
              this.$swal("", error.response.statusText, "error");
              this.$router.push({ name: "login" });
            } else {
              this.$swal("", "Something went wrong", "error");
            }
          } else {
            this.$swal("", error.message, "error");
          }
        });
     //.finally(() => (this.loading = false));
    },
  },
};

</script>
